// removed by extract-text-webpack-plugin
module.exports = {"leftPicture":"src-components-Section----LeftPicture-module---leftPicture---3Nind","fh5co-lead":"src-components-Section----LeftPicture-module---fh5co-lead---XwMtS","fh5colead":"src-components-Section----LeftPicture-module---fh5colead---OR1b0","fh5cosublead":"src-components-Section----LeftPicture-module---fh5cosublead---gI5Wm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Section/LeftPicture.module.scss
// module id = 429
// module chunks = 168707334958949